export const internals = {
  web: {
    subdomain: window.location.host,
    locale: window.location.pathname.split("/")[2]
  },

  async getAuthorizationToken() {
    return fetch('/hc/api/internal/csrf_token.json')
      .then((response) => response.json())
      .then((response) => response.current_session.csrf_token)
      .catch((response) => {
        console.error(new Error(response));
      });
  }
}